import {
    CrudBase
} from "../../crud";
import {
    BasicCrud
} from "../../../utils/interfaces/crud/imp/crud-basic";
import {
    WorkflowModel
} from "../../../models/workflow";
import {
    WorkflowStep
} from "./sections/workflow-step";

export class _WorkflowController extends CrudBase {
    createModel = WorkflowModel;
    loading = false;
    list = []
    currentSystemModule = null
    workflowSteps = []
    // formData 
    constructor() {
        super({
            name: "workflow",
            modules: {
                crud: new BasicCrud()
            },
            model: WorkflowModel
        });
    }

    onReady() {
        this.sections = {
            workflow_step: new WorkflowStep(this)
        }
        this.actions = this.repo.workflow;
    }

    async getWorkflows(systemCode) {
        this.currentSystemModule = this.app.systemModules[systemCode];
        let response = await this.execute(this.actions.getBySystemCode, null, systemCode);
        this.list = response.data
    }

    async create() {
        let response = await this.execute(this.actions.create, this.formData);
        if (response.success) {
            this.app.$refs.snackbarAlert.show({
                colour: "success",
                text: `${this.currentSystemModule.systemCode} successfully created`
            })
            this.app.$router.push(
                `/Workflow/${this.currentSystemModule.systemCode}`
            );
        }
    }

    getCurrentSystemModule() {
        if (this.currentSystemModule == null) {
            this.currentSystemModule = this.app.systemModules[this.app.$route.params.systemCode];
        }
        return this.currentSystemModule
    }

    async update() {
        let response = await this.execute(this.actions.update, this.formData);
        if (response.success) {
            this.app.$router.push(
                `/Workflow/${this.currentSystemModule.systemCode}`
            );
            this.app.$refs.snackbarAlert.show({
                colour: "success",
                text: `${this.currentSystemModule.systemCode} successfully updated`
            })
        }
    }

    async onAdd() {
        this.formData = this.currentSystemModule.createWorkflow();
        if (this.formData.workflowSteps == undefined) {
            this.formData.workflowSteps = []
        }
        this.app.$router.push(`/Workflow/${this.currentSystemModule.systemCode}/maint/${0}`);
    }

    async delete(item) {
        this.app.$refs.confirmationDialog.showDialog({
            title: `Delete ${this.currentSystemModule.name}`,
            message: `Are you sure you wish to delete this ${this.currentSystemModule.name}?`,
            callback: "onDeleted",
            callbackData: item,
            controller: "workflow"
        });
    }

    async onDeleted(item) {
        let response = await this.execute(this.actions.delete, null, `?id=${item.id}`);
        if (response.success) {
            this.list.splice(this.list.indexOf(item), 1);
        }
        this.app.$refs.snackbarAlert.show({
            colour: "success",
            text: `${this.currentSystemModule.systemCode} successfully deleted`
        })
    }

    async onStepDeleted(item) {
        let response = await this.execute(this.actions.deleteStep, null, `?id=${item.id}`);
        if (response.success) {
            this.getWorkflowSteps(item.workFlowId)
            this.app.$refs.snackbarAlert.show({
                colour: "success",
                text: `Step successfully deleted`
            })
        }
    }

    async getWorkflowSteps(worfklowId) {
        let response = await this.execute(this.actions.GetAllWorkflowSteps, null, `?WorkflowId=${worfklowId}`)
        this.sections["workflow_step"].steps = []
        if (response.success) {
            this.sections["workflow_step"].totalSteps = response.data.length
            let mapped = []
            response.data.forEach(element => {
                let foundStep = mapped.find(x => x.rank == element.rank)
                if (foundStep == undefined) {
                    let newMap = {
                        rank: element.rank,
                        steps: [element]
                    }
                    mapped.push(newMap)
                } else {
                    foundStep.steps.push(element)
                }
            });
            this.sections["workflow_step"].steps = mapped
        }
    }

    async editSteps(item) {
        await this.getWorkflowSteps(item.id)
        this.app.$router.push(
            `/Workflow/${this.currentSystemModule.systemCode}/Steps/${item.id}`
        );
    }

    async onEdit(item) {
        this.formData = item;
        this.app.$router.push(`/Workflow/${this.currentSystemModule.systemCode}/maint/${item.id}`);
    }

    async goToSend(item) {
        this.formData = item;
        this.app.$router.push(
            `/Workflow/${this.currentSystemModule.systemCode}/Send/${item.id}`
        );
    }
}

export const WorkflowController = new _WorkflowController();